<template>
  <div class="container">
    <div class="search-box" :class="isFocusFlag ? 'border-searching' : ''">
      <div class="search-icon" :class="isFocusFlag ? 'si-rotate' : ''">
        <i
          class="el-icon-search el-icon search-icon"
          :class="isFocusFlag ? 'si-rotate' : ''"
        ></i>
      </div>
      <form action="" class="search-form">
        <input
          @focus="onFocusEvent"
          @blur="onBlurEvent"
          v-model="inputValue"
          type="text"
          class="search"
          :placeholder="placeholderText"
          @input="inputChange"
          autocomplete="off"
        />
      </form>
      <span class="search_border"></span>
      <div
        class="clear-icon"
        :class="isShowClearIcon ? 'isShow' : ''"
        @click="clearSearch"
      >
        <i class="el-icon-circle-close el-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom_searchBox',
  props: {
    placeholderText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFocusFlag: false,
      isShowClearIcon: false,
      inputValue: '',
    }
  },
  methods: {
    onFocusEvent() {
      this.isFocusFlag = true
    },
    onBlurEvent() {
      this.isFocusFlag = false
    },
    inputChange(val) {
      // console.debug(val)
      this.searchData(val.target.value)
    },
    filterInputValHandler(val) {
      if (val) {
        this.isShowClearIcon = true
      } else {
        this.isShowClearIcon = false
      }
      this.$emit('filterInputVal', {
        val,
        placeholder: this.placeholderText,
      })
    },
    searchData(val) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.filterInputValHandler(val) //查询表格内容的函数，此处省略
      }, 300)
      //后面数为多少毫秒不变之后执行
    },
    clearSearch() {
      this.isShowClearIcon = false
      this.inputValue = ''
      this.$emit('filterInputVal', {
        val: this.inputValue,
        placeholder: this.placeholderText,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
*,
*:before,
*:after {
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  user-select: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  padding: 0;
  margin: 0;
}
a,
a:visited,
a:hover {
  color: inherit;
  text-decoration: none;
}
.container {
  position: relative;
  padding: 0 0.694vw;
  width: 100%;
}
.search-box {
  position: relative;
  width: 100%;
  height: 2.083vw;
  border-radius: 50%;
  margin: 0 auto;
}
.search-icon,
.clear-icon {
  position: absolute;
  top: 0;
  height: 2.083vw;
  width: 2.083vw;
  line-height: 2.083vw;
  text-align: center;
}
.search-icon {
  transition: transform 0.3s linear;
}

.search-icon {
  left: 0;
  pointer-events: none;
  font-size: 1.11vw;
  will-change: transform;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -moz-transform-origin: center center;
  -o-transform-origin: center center;
  transition: transform 400ms 220ms cubic-bezier(0.19, 1, 0.22, 1);
  -webkit-transition: transform 400ms 220ms cubic-bezier(0.19, 1, 0.22, 1);
  -moz-transition: transform 400ms 220ms cubic-bezier(0.19, 1, 0.22, 1);
  -o-transition: transform 400ms 220ms cubic-bezier(0.19, 1, 0.22, 1);
}
.si-rotate {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
}
.clear-icon {
  right: 0;
  pointer-events: none;
  font-size: 1.11vw;
  will-change: opacity;
  opacity: 0;
  z-index: 20;
  /* transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transition: opacity 190ms ease-out,
    transform 260ms cubic-bezier(0.19, 1, 0.22, 1);
  -webkit-transition: opacity 190ms ease-out,
    transform 260ms cubic-bezier(0.19, 1, 0.22, 1);
  -moz-transition: opacity 190ms ease-out,
    transform 260ms cubic-bezier(0.19, 1, 0.22, 1);
  -o-transition: opacity 190ms ease-out,
    transform 260ms cubic-bezier(0.19, 1, 0.22, 1); */
  transition: opacity 0.3s linear;
  &.isShow {
    opacity: 1;
    pointer-events: all;
  }
}
.go-in {
  opacity: 1;
  pointer-events: all;
  cursor: pointer;
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -moz-transform: rotate(0);
  -o-transform: rotate(0);
  transition: opacity 190ms ease-out,
    transform 260ms 20ms cubic-bezier(0.19, 1, 0.22, 1);
  -webkit-transition: opacity 190ms ease-out,
    transform 260ms 20ms cubic-bezier(0.19, 1, 0.22, 1);
  -moz-transition: opacity 190ms ease-out,
    transform 260ms 20ms cubic-bezier(0.19, 1, 0.22, 1);
  -o-transition: opacity 190ms ease-out,
    transform 260ms 20ms cubic-bezier(0.19, 1, 0.22, 1);
}

.border-searching {
  .search_border {
    border-radius: 0;
    border-width: 0 0 1px 0;
    width: calc(100% - 1.388vw);
    left: 0.694vw;
  }
}
.search {
  font-family: 'Montserrat Alternates', sans-serif;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0);
  padding: 0 2.083vw;
  color: var(--mixtmt_whiteColor);
  font-size: 0.972vw;
  font-weight: 500;
  letter-spacing: -0.015em;
  outline: none;
}
.search_border {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;
  width: 100%;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  border-color: var(--mixtmt_whiteColor);
  border-radius: 2.083vw;
  transition: all 0.3s linear;
}
.search::-webkit-input-placeholder {
  color: var(--mixtmt_greyColor9);
}
.search::-moz-placeholder {
  color: var(--mixtmt_greyColor9);
}
.search::-ms-input-placeholder {
  color: var(--mixtmt_greyColor9);
}
.search::-moz-placeholder {
  color: var(--mixtmt_greyColor9);
}
.search::-moz-selection {
  color: var(--mixtmt_greyColor9);
  background: rgba(0, 0, 0, 0.25);
}
.search::selection {
  color: var(--mixtmt_greyColor9);
  background: rgba(0, 0, 0, 0.25);
}

.mixtmt_pc {
  .clear-icon {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
